export function DashboardIcon(props) {
  return (
    <svg
      width={16}
      height={17}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.013 5.599v-.001a.862.862 0 01-.274-.654V2.278c0-.262.083-.465.274-.655a.864.864 0 01.654-.273h3.555c.262 0 .465.083.655.273s.273.393.273.655v2.666a.864.864 0 01-.273.655.865.865 0 01-.655.273h-3.555a.862.862 0 01-.654-.273zM1.778 15.65a.866.866 0 01-.655-.273.866.866 0 01-.273-.655V2.278c0-.262.083-.465.273-.655a.866.866 0 01.655-.273h3.555c.262 0 .465.083.655.273s.273.393.273.655v12.444a.867.867 0 01-.273.655.866.866 0 01-.655.273H1.778zm8.889 0a.864.864 0 01-.654-.273.865.865 0 01-.274-.655v-4.444c0-.262.083-.465.274-.655a.864.864 0 01.654-.273h3.555c.262 0 .465.083.655.273s.273.393.273.655v4.444a.867.867 0 01-.273.655.867.867 0 01-.655.273h-3.555z"
        stroke="#FBFBFB"
        strokeWidth={1.7}
      />
    </svg>
  )
}

export function IncomeSvg(props) {
  return (
    <svg
      width={60}
      height={60}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M39.93 1.69A30 30 0 00.011 29.15l14.568.413a15.427 15.427 0 0120.526-14.119l4.823-13.752z"
        fill="#E4E8EF"
      />
      <path
        d="M.243 26.19A30 30 0 1038.384 1.194l-4.073 13.993A15.427 15.427 0 1114.7 28.04L.243 26.19z"
        fill="#29b8e3"
      />
    </svg>
  )
}

export function ExpensesSvg(props) {
  return (
    <svg
      width={60}
      height={60}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M39.93 1.69A30 30 0 00.011 29.15l14.568.413a15.427 15.427 0 0120.526-14.119l4.823-13.752z"
        fill="#E4E8EF"
      />
      <path
        d="M.243 26.19A30 30 0 1038.384 1.194l-4.073 13.993A15.427 15.427 0 1114.7 28.04L.243 26.19z"
        fill="#FF4949"
      />
    </svg>
  )
}

export function RemainingSvg(props) {
  return (
    <svg
      width={60}
      height={60}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M39.93 1.69A30 30 0 00.011 29.15l14.568.413a15.427 15.427 0 0120.526-14.119l4.823-13.752z"
        fill="#E4E8EF"
      />
      <path
        d="M.243 26.19A30 30 0 1038.384 1.194l-4.073 13.993A15.427 15.427 0 1114.7 28.04L.243 26.19z"
        fill="#F29A2E"
      />
    </svg>
  )
}

export function EmailConfirmIcon(props) {
  return (
    <svg
      width={96}
      height={96}
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx={48} cy={48} r={48} fill="#AFFAE8" />
      <path
        d="M30 43.62v18.884c0 .385.154.755.428 1.027.273.273.645.426 1.032.426h32.12c.387 0 .758-.153 1.032-.426.274-.272.428-.642.428-1.027V43.621L47.52 32 30 43.62zM44.335 53.789L30.45 63.546M64.59 63.546L50.705 53.79"
        stroke="#14AF8A"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M65.04 43.62L50.705 53.79h-6.37L30 43.62"
        stroke="#14AF8A"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}